/* CALIMPORT B2B v0 — sesion de cliente y precios.

   El precio lista es REAL: sale de variant.price y lo emite el snippet
   'precio' en data-precio. Los productos con precio 0 en Shopify se muestran
   como "Bajo cotizacion" — no hay lista cargada para ellos.

   MAQUETA (solo 127.0.0.1, nunca en el sitio publicado):
     - La SESION es inventada: quien mira y que descuento tiene.
     - Los PRECIOS pueden ser inventados tambien, para ver la grilla con una
       mezcla de productos con y sin precio. Se prende y apaga en la pildora,
       que dice cual esta activo.
   En el sitio publicado no hay sesion ni precios inventados: todos ven el
   precio lista de Shopify, sin descuento.

   Cuando exista el App Proxy cambian dos funciones y nada mas:
     clmB2BSesion()  -> lee window.CLM_CUSTOMER (lo emite layout/theme.liquid)
     clmB2BPrecios() -> pide el descuento del cliente a /apps/b2b/precios
   Los tres estados (anonimo / pendiente / aprobado) y como se pintan son el
   diseño definitivo.
*/

var CLM_B2B_KEY   = 'clm_b2b_demo';
var CLM_B2B_LOCAL = location.hostname === '127.0.0.1' || location.hostname === 'localhost';

/* Las paginas de cuenta todavia no existen en el admin de Shopify, asi que en
   local se sirven como plantilla alternativa (?view=) colgando de una pagina
   que si existe. Al crearlas en el admin solo cambia esta constante. */
var CLM_B2B_URL_LOGIN  = CLM_B2B_LOCAL ? '/pages/cotizacion?view=ingresar' : '/pages/ingresar';
var CLM_B2B_URL_CUENTA = CLM_B2B_LOCAL ? '/pages/cotizacion?view=cuenta'   : '/pages/cuenta';

/* El endpoint del proxy no existe todavia: sin esto, cada ficha dispararia un
   404 contra Shopify. Se prende cuando la fase 2 este desplegada. */
var CLM_B2B_PROXY_ON = false;

/* Cliente de mentira para la maqueta. Los descuentos por marca son el escenario
   3 del plan (el mas probable en distribucion electrica): un % distinto por
   fabricante en vez de uno solo para todo el catalogo. */
var CLM_B2B_DEMO_CLIENTE = {
  estado:           'aprobado',
  origen:           'demo',
  nombre:           'Patricia Villalobos',
  cargo:            'Jefatura de Abastecimiento',
  empresa:          'Ingenieria y Montajes Andes SpA',
  rut:              '76.543.210-8',
  cardcode:         'C765432108',
  email:            'compras@imandes.cl',
  telefono:         '+56 9 8765 4321',
  sucursal:         'Santiago',
  lista:            'Lista 2 — Distribuidor',
  moneda:           'CLP',
  condicion:        '30 dias',
  ejecutivo:        'Rodrigo Fuentes',
  ejecutivo_email:  'rfuentes@calimport.cl',
  ejecutivo_fono:   '+56 2 2345 6789',
  descuento:        18,
  descuentos_marca: {
    'siemens':         22,
    'abb':             15,
    'phoenix contact': 20,
    'finder':          12,
    'circutor':        14
  }
};

var CLM_B2B_DEMO_COTIZACIONES = [
  { folio: 'CV-2026-0148', fecha: '21-08-2026', items: 7,  monto: 1284500, estado: 'Enviada'   },
  { folio: 'CV-2026-0131', fecha: '12-08-2026', items: 3,  monto: 296400,  estado: 'Aceptada'  },
  { folio: 'CV-2026-0097', fecha: '28-07-2026', items: 14, monto: 4137800, estado: 'Aceptada'  },
  { folio: 'CV-2026-0064', fecha: '09-07-2026', items: 2,  monto: 88900,   estado: 'Vencida'   }
];

/* ===== utilidades ===== */

function clmB2BEsc(s){
  return String(s == null ? '' : s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

/* CLP: sin decimales y con punto de miles. Intl.NumberFormat haria lo mismo,
   pero en es-CL algunos navegadores meten el simbolo pegado y otros no. */
function clmB2BFmt(n){
  return '$' + Math.round(n || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

/* ===== sesion ===== */

function clmB2BSesion(){
  if (CLM_B2B_LOCAL) {
    try { return JSON.parse(localStorage.getItem(CLM_B2B_KEY)) || null; } catch(e){ return null; }
  }

  /* Produccion. Hoy customer siempre viene nulo porque las cuentas de cliente
     no estan activadas; cuando lo esten, el tag manda: la aprobacion comercial
     es lo unico que abre los precios. */
  var c = window.CLM_CUSTOMER;
  if (!c) return null;

  var tags = (c.tags || []).map(function(t){ return String(t).toLowerCase(); });
  return {
    estado:   tags.indexOf('b2b-aprobado') !== -1 ? 'aprobado' : 'pendiente',
    origen:   'shopify',
    nombre:   c.nombre || '',
    email:    c.email || ''
  };
}

function clmB2BEntrar(estado){
  var ses = JSON.parse(JSON.stringify(CLM_B2B_DEMO_CLIENTE));
  ses.estado = estado || 'aprobado';
  try { localStorage.setItem(CLM_B2B_KEY, JSON.stringify(ses)); } catch(e){}
  return ses;
}

function clmB2BSalir(){
  try { localStorage.removeItem(CLM_B2B_KEY); } catch(e){}
}

/* ===== precios ===== */

function clmB2BDescuento(ses, marca){
  if (!ses) return 0;
  var m = String(marca || '').trim().toLowerCase();
  var porMarca = ses.descuentos_marca || {};
  if (m && porMarca[m] != null) return porMarca[m];
  return ses.descuento || 0;
}

/* El precio lista lo pone Liquid en data-precio (variant.price, en centavos);
   lo unico que falta es el descuento del cliente. Hoy sale de la sesion de
   maqueta, mañana de /apps/b2b/precios: el descuento es lo unico que no puede
   viajar por Liquid, porque es distinto para cada cliente. */
function clmB2BPrecios(lista, marca, ses, conDescuento){
  var desc = conDescuento ? clmB2BDescuento(ses, marca) : 0;
  return {
    lista:     lista,
    descuento: desc,
    /* A la decena: SAP nunca devuelve precios con peso partido. */
    neto:      desc > 0 ? Math.round(lista * (1 - desc / 100) / 10) * 10 : lista
  };
}

/* ===== precios inventados (solo local) =====

   Para revisar el diseño hace falta una mezcla: si la tienda tiene casi todo
   en 0, la grilla se ve toda igual y no se alcanza a juzgar. Con esto ~1 de
   cada 5 SKUs queda en 0 y el resto cae en tres rangos que imitan el catalogo
   (fungibles, aparamenta, equipos). Deterministico por SKU: el mismo producto
   sale igual en la grilla, en la ficha y despues de recargar.

   Se prende y apaga desde la pildora de maqueta, que dice cual esta activo. */

var CLM_B2B_PRECIOS_KEY = 'clm_b2b_precios_demo';

/* Apagado (02-10-2026): en local la ficha tiene que verse igual que en vivo,
   con el precio real de Shopify (o "Bajo cotizacion" si es 0). Para volver a
   usar precios inventados en la maqueta, descomentar el bloque de abajo. */
function clmB2BPreciosDemoOn(){
  return false;
  // if (!CLM_B2B_LOCAL) return false;
  // try {
  //   var v = localStorage.getItem(CLM_B2B_PRECIOS_KEY);
  //   return v === null ? true : v === '1';
  // } catch(e){ return true; }
}

function clmB2BPreciosDemoSet(on){
  try { localStorage.setItem(CLM_B2B_PRECIOS_KEY, on ? '1' : '0'); } catch(e){}
}

/* FNV-1a. Solo necesita ser estable y repartir parejo. */
function clmB2BHash(s, semilla){
  var h = semilla || 2166136261;
  for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0;
}

function clmB2BPrecioInventado(sku){
  if (!sku) return 0;
  var s = String(sku).toUpperCase();

  var bucket = clmB2BHash(s) % 100;
  if (bucket < 22) return 0;

  var rango;
  if (bucket < 62)      rango = [1500, 25000];      // bornes, terminales, fusibles
  else if (bucket < 88) rango = [25000, 180000];    // interruptores, contactores, reles
  else                  rango = [180000, 1200000];  // variadores, PLC, analizadores

  var v = clmB2BHash(s, 3266489917);
  return Math.round((rango[0] + (v % (rango[1] - rango[0]))) / 10) * 10;
}

/* ===== pintado ===== */

var clmB2BPintando = false;

function clmB2BHtmlFicha(p){
  /* Precio 0 en Shopify = producto sin lista cargada: se cotiza. */
  if (p.lista <= 0) {
    return ''
      + '<div style="background:#FFF3EC;border-radius:8px;border-left:3px solid #F26522;padding:10px 14px;">'
      +   '<p style="font-size:13px;font-weight:600;color:#D4501A;margin-bottom:2px;">Bajo cotización</p>'
      +   '<p style="font-size:12px;color:#9CA3AF;margin:0;">Solicita tu cotización y te respondemos lo antes posible.</p>'
      + '</div>';
  }

  var conDesc = p.estado === 'aprobado' && p.descuento > 0;
  var pie = '';

  if (conDesc) {
    pie = '<div style="font-size:11px;color:#9CA3AF;margin-top:10px;padding-top:9px;border-top:1px solid #F3F4F6;line-height:1.5;">'
        +   'Valor referencial. El precio final se confirma en la cotización.'
        + '</div>';
  } else if (p.estado === 'anonimo') {
    pie = '<div style="margin-top:10px;padding-top:9px;border-top:1px solid #F3F4F6;">'
        +   '<a href="' + CLM_B2B_URL_LOGIN + '" style="display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;color:#F26522;text-decoration:none;">'
        +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
        +     'Inicia sesión para ver tu precio'
        +   '</a>'
        + '</div>';
  } else if (p.estado === 'pendiente') {
    pie = '<div style="font-size:11px;color:#B45309;margin-top:10px;padding-top:9px;border-top:1px solid #F3F4F6;line-height:1.5;">'
        +   'Tu cuenta está en revisión. Cuando comercial la apruebe verás tu precio aquí.'
        + '</div>';
  }

  return ''
    + '<div style="border:1px solid #E5E7EB;border-radius:10px;padding:14px 16px;background:#fff;">'
    +   '<div style="display:flex;align-items:baseline;justify-content:space-between;gap:12px;margin-bottom:2px;">'
    +     '<span style="font-size:10px;font-weight:700;color:#6B7280;letter-spacing:.8px;text-transform:uppercase;">'
    +       (conDesc ? 'Tu precio' : 'Precio lista')
    +     '</span>'
    +     (conDesc
            ? '<span style="font-size:11px;font-weight:800;color:#D4501A;background:#FFF3EC;border-radius:999px;padding:3px 9px;">-' + p.descuento + '%</span>'
            : '')
    +   '</div>'
    +   '<div style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;">'
    +     '<span style="font-size:28px;font-weight:800;color:#003A70;line-height:1.1;">' + clmB2BFmt(p.neto) + '</span>'
    +     '<span style="font-size:12px;color:#6B7280;font-weight:600;">+ IVA</span>'
    +   '</div>'
    +   (conDesc
          ? '<div style="font-size:12px;color:#9CA3AF;margin-top:4px;">Precio lista <s>' + clmB2BFmt(p.lista) + '</s></div>'
          : '')
    +   pie
    + '</div>';
}

function clmB2BHtmlTarjeta(p){
  if (p.lista <= 0) {
    return '<div style="font-size:11.5px;color:#D4501A;font-weight:700;">Bajo cotización</div>';
  }

  var conDesc = p.estado === 'aprobado' && p.descuento > 0;

  return ''
    + '<div style="display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;">'
    +   '<span style="font-size:16px;font-weight:800;color:#003A70;">' + clmB2BFmt(p.neto) + '</span>'
    +   '<span style="font-size:10px;color:#6B7280;font-weight:600;">+ IVA</span>'
    +   (conDesc
          ? '<span style="font-size:10px;font-weight:800;color:#D4501A;background:#FFF3EC;border-radius:999px;padding:2px 6px;margin-left:auto;">-' + p.descuento + '%</span>'
          : '')
    + '</div>'
    + (conDesc
        ? '<div style="font-size:10.5px;color:#9CA3AF;"><s>' + clmB2BFmt(p.lista) + '</s></div>'
        : '');
}

function clmB2BPintarUno(el, ses, demoPrecios){
  var sku    = el.getAttribute('data-sku') || '';
  var marca  = el.getAttribute('data-vendor') || '';
  var ctx    = el.getAttribute('data-contexto') || 'ficha';
  var estado = ses ? ses.estado : 'anonimo';

  /* variant.price viene en centavos aunque el peso no tenga decimales. */
  var lista = (parseInt(el.getAttribute('data-precio') || '0', 10) || 0) / 100;
  if (demoPrecios) lista = clmB2BPrecioInventado(sku);

  /* El descuento solo se aplica si hay de donde sacarlo de verdad: la maqueta
     local o, cuando exista, el proxy. En produccion sin proxy el cliente
     aprobado ve el precio lista, nunca un descuento inventado. */
  var conDesc = estado === 'aprobado' && (ses.origen === 'demo' || CLM_B2B_PROXY_ON);

  var p = clmB2BPrecios(lista, marca, ses, conDesc);
  p.estado = estado;

  /* Firma: evita repintar en cada mutacion del DOM (y con eso, el bucle
     infinito con el MutationObserver que dispara el propio pintado). */
  var firma = estado + '|' + p.lista + '|' + p.descuento;
  if (el.getAttribute('data-clm-firma') === firma) return;
  el.setAttribute('data-clm-firma', firma);

  el.innerHTML = ctx === 'tarjeta' ? clmB2BHtmlTarjeta(p) : clmB2BHtmlFicha(p);
}

function clmB2BPintar(root){
  var nodos = (root || document).querySelectorAll('[data-clm-precio]');
  if (!nodos.length) return;
  clmB2BPintando = true;
  var ses   = clmB2BSesion();
  var demoP = clmB2BPreciosDemoOn();
  for (var i = 0; i < nodos.length; i++) clmB2BPintarUno(nodos[i], ses, demoP);
  clmB2BPintando = false;
}

/* ===== chrome (cabecera + pildora) ===== */

/* El icono de la cabecera lleva al login o a la cuenta segun haya sesion.
   Fuera de local se esconde: las paginas /pages/ingresar y /pages/cuenta
   todavia no existen en el admin, asi que un push dejaria un 404 a la vista.
   Se prende borrando el guard de abajo el dia que las paginas existan. */
function clmB2BAcceso(ses){
  var a = document.querySelector('[data-b2b-acceso]');
  if (!a) return;
  if (!CLM_B2B_LOCAL) { a.style.display = 'none'; return; }
  var dentro = !!ses;
  a.setAttribute('href', dentro ? CLM_B2B_URL_CUENTA : CLM_B2B_URL_LOGIN);
  a.setAttribute('title', dentro ? 'Mi cuenta' : 'Ingresar');
  a.setAttribute('aria-label', dentro ? 'Mi cuenta' : 'Ingresar');
  a.style.color = dentro ? '#003A70' : '';
  var dot = a.querySelector('.clm-acceso-dot');
  if (dot) dot.style.display = dentro ? '' : 'none';
}

/* Pildora de modo maqueta: solo en local. Dos interruptores — quien mira y de
   donde salen los precios — para poder recorrer todo el sitio sin volver a la
   pantalla de login ni tocar el codigo. Dice siempre cual esta activo: si los
   precios son inventados, tiene que verse. */
function clmB2BUi(){
  var ses = clmB2BSesion();
  clmB2BAcceso(ses);
  if (!CLM_B2B_LOCAL || !document.body) return;

  var vieja = document.getElementById('clm-b2b-pildora');
  if (vieja) vieja.remove();

  var demoP = clmB2BPreciosDemoOn();
  var boton = 'background:none;border:none;color:#FFB48A;font:inherit;cursor:pointer;padding:0;text-decoration:underline;';

  var d = document.createElement('div');
  d.id = 'clm-b2b-pildora';
  d.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:9999;display:flex;align-items:center;gap:9px;'
                  + 'background:#003A70;color:#fff;border-radius:999px;padding:7px 15px;font-size:11.5px;'
                  + 'font-weight:700;box-shadow:0 6px 20px rgba(0,58,112,.28);opacity:.94;';
  d.innerHTML = '<span style="opacity:.55;font-weight:600;">maqueta</span>'
    + '<button type="button" data-b2b-estado style="' + boton + '">' + clmB2BEsc(ses ? ses.estado : 'sin sesión') + '</button>'
    + '<span style="opacity:.3;">|</span>'
    + '<button type="button" data-b2b-precios style="' + boton + '">precios ' + (demoP ? 'inventados' : 'reales') + '</button>';
  document.body.appendChild(d);

  /* Cicla: sin sesion -> aprobado -> pendiente -> sin sesion */
  d.querySelector('[data-b2b-estado]').addEventListener('click', function(){
    if (!ses)                         clmB2BEntrar('aprobado');
    else if (ses.estado === 'aprobado') clmB2BEntrar('pendiente');
    else                              clmB2BSalir();
    clmB2BPintar(document);
    clmB2BUi();
  });

  d.querySelector('[data-b2b-precios]').addEventListener('click', function(){
    clmB2BPreciosDemoSet(!demoP);
    clmB2BPintar(document);
    clmB2BUi();
  });
}

/* ===== arranque ===== */

document.addEventListener('DOMContentLoaded', function(){
  clmB2BPintar(document);
  clmB2BUi();

  /* El buscador inyecta tarjetas en la grilla despues de cargar la pagina
     (templates/search.cards.liquid), asi que hay que pintar tambien eso. */
  if (window.MutationObserver && document.body) {
    var pendiente = null;
    new MutationObserver(function(){
      if (clmB2BPintando) return;
      clearTimeout(pendiente);
      pendiente = setTimeout(function(){ clmB2BPintar(document); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
});

window.CLM_B2B = {
  sesion:        clmB2BSesion,
  entrar:        clmB2BEntrar,
  salir:         clmB2BSalir,
  precios:       clmB2BPrecios,
  descuento:     clmB2BDescuento,
  fmt:           clmB2BFmt,
  esc:           clmB2BEsc,
  pintar:        clmB2BPintar,
  ui:            clmB2BUi,
  cotizaciones:  CLM_B2B_DEMO_COTIZACIONES,
  urlLogin:      CLM_B2B_URL_LOGIN,
  urlCuenta:     CLM_B2B_URL_CUENTA
};
